
define('text!templates/pages/trade/offer/repeat/navbar.ejs',[],function () { return '<a href="javascript:void(0);" class="btn btn-link" id="repeat-select-all">\n    <i class="icon icon-check"></i>&nbsp;Выделить все\n</a>\n\n<a href="javascript:void(0);" class="btn btn-link" id="repeat-clear-selection">\n    <i class="icon icon-remove"></i>&nbsp;Снять выделение\n</a>';});

